import { buildAlignedTotalsRow, getColumnIndex } from '@components/shared/Table/helpers/buildAlignedTotalsRow'
import { numberMask } from '@utils/masks/cpfMask'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { ClientDataResponseProps } from '../context/types'

interface ParseClientsTotalsProps {
  columns: ColumnDefProps[]
  data: ClientDataResponseProps | null
}

/**
 * Linha de totais da tabela de Clientes: Total Bruto sob "Faturamento Bruto (R$)" e
 * Total Líquido sob "Faturamento Líquido (R$)" — nessa ordem, sem inversão.
 */
export const parseClientsTotalsGrid = ({ columns, data }: ParseClientsTotalsProps): ColumnDefProps[][] => {
  if (!columns.length || !data) return []

  const totalsRow = buildAlignedTotalsRow({
    columns,
    label: `Total Registros: ${numberMask(String(data.totalItems || 0))}`,
    labelSpan: getColumnIndex(columns, 'grossRevenue'),
    values: {
      grossRevenue: { label: 'Total Bruto', value: data.grossTotalAmount || 0, currency: true },
      netRevenue: { label: 'Total Líquido', value: data.netTotalAmount || 0, currency: true }
    }
  })

  return totalsRow.length ? [totalsRow] : []
}
